/** The server's tag palette (src/graphql/photos/tag.ts). */
export const TAG_COLORS = ['gray', 'red', 'orange', 'yellow', 'green', 'teal', 'blue', 'purple'] as const

/** Dot colours — literal classes so Tailwind keeps them. */
const TAG_DOT: Record<string, string> = {
  gray: 'bg-gray-400',
  red: 'bg-red-500',
  orange: 'bg-orange-500',
  yellow: 'bg-yellow-500',
  green: 'bg-green-500',
  teal: 'bg-teal-500',
  blue: 'bg-blue-500',
  purple: 'bg-purple-500',
}

export const tagColorClass = (color: string): string => TAG_DOT[color] ?? TAG_DOT.gray

export const tagNameTaken = (name: string, tags: { name: string }[]): boolean => {
  const n = name.trim().toLowerCase()
  return tags.some((x) => x.name.toLowerCase() === n)
}

export const sortTagsForPicker = <T extends { name: string; usageCount: number }>(tags: T[]): T[] =>
  tags.slice().sort((a, b) => b.usageCount - a.usageCount || a.name.localeCompare(b.name))
